<template>
  <a-modal
    title="添加"
    :width="1080"
    :visible="visible"
    @ok="modalok"
    @cancel="modalcancel"
    :footer="null"
  >
    <div>
      <a-steps :current="index">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" :content="item.content" />
      </a-steps>
      <div class="steps-content" style="margin-top: 20px">
        <div v-if="index === 0">
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="4">
                <a-col span="6">
                  <a-form-item label="名称">
                    <a-input v-model="queryParam.name" placeholder="请输入" allowClear/>
                  </a-form-item>
                </a-col>
                <a-col span="6">
                  <a-form-item label="位置">
                    <a-select default-value="" style="width: 100%" v-model="queryParam.location" allowClear placeholder="请选择">
                      <a-select-option v-for="item in this.$Dictionaries.location" :value="Object.keys(item)[0]" :key="Object.values(item)[0]"> {{ Object.values(item)[0] }} </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="6">
                  <a-form-item label="资产类型">
                    <a-select default-value="" style="width: 100%" v-model="queryParam.property_type" allowClear placeholder="请选择" >
                      <a-select-option v-for="(val, key) in this.$Dictionaries.property_type" :value="key" :key="key">
                        {{ val }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="6">
                  <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <s-table
            :customRow="itemClick"
            ref="table"
            :showSizeChanger="false"
            :pageSize="5"
            size="small"
            rowKey="id"
            :loading="loading"
            :columns="columns"
            :data="loadData"
          >
          </s-table>
        </div>
        <div v-else-if="index === 1">
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="4">
                <a-col span="6">
                  <a-form-item label="名称">
                    <a-input v-model="queryCellParam.name" placeholder="请输入" allowClear/>
                  </a-form-item>
                </a-col>
                <a-col span="6">
                  <a-button type="primary" @click="getZonePropertyCellsList(-1)">查询</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <a-table
            ref="table2"
            size="small"
            rowKey="id"
            :pagination="{ pageSize: 5, defaultPageSize: 5,current:this.current,total: this.propertyCellTotal,showSizeChanger: false }"
            :loading="cell_loading"
            :customRow="itemCellClick"
            :columns="columns_cell"
            :dataSource="zonePropertyCellsList"
          >
          </a-table>
        </div>
        <div v-else-if="index === 2">
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="4">
                <a-col span="6">
                  <a-form-item label="编号">
                    <a-input v-model="queryCellChopsParam.number" placeholder="请输入" allowClear/>
                  </a-form-item>
                </a-col>
                <a-col span="6">
                  <a-button type="primary" @click="getZonePropertyCellChopsList(undefined)">查询</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <a-table
            ref="table3"
            size="small"
            rowKey="id"
            :row-selection="rowSelection"
            :pagination="{ pageSize: 100, defaultPageSize: 100,current:this.propertyCellChopsCurrent,total: this.propertyCellChopsTotal,showSizeChanger: false }"
            :loading="cell_loading"
            :columns="columnsCellChops"
            :dataSource="zonePropertyCellChopsList"
          >
          </a-table>
        </div>
        <div v-if="selectedCellChopsList.length > 0 && index === 3">
          <a-table
            ref="table4"
            size="small"
            rowKey="id"
            :pagination="{ pageSize: 100, defaultPageSize: 100,current:1,total: this.selectedCellChopsList.length,showSizeChanger: false }"
            :columns="columnsCellChopsSelected"
            :data-source="selectedCellChopsList"
          >
            <span slot="action" slot-scope="text, record">
              <template>
                <a-popconfirm
                  title="确定要删除么？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="handleDelete(record)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </template>
            </span>
          </a-table>
        </div>
      </div>
      <div class="steps-action">
        <a-button v-if="index > 0" style="margin-left: 8px" @click="prev">
          上一步
        </a-button>
        <a-button style="margin-left: 10px" v-if="index < steps.length - 1" type="primary" @click="next">
          下一步
        </a-button>
        <a-button
          style="margin-left: 10px"
          v-if="index === steps.length - 1"
          type="primary"
          @click="modalok"
        >
          完成
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
import {
  zone_property_list
} from '@/api/zone_property'
import {
  zone_property_cell_list,
  zone_property_cell_chops_list
} from '@/api/zone_property_cell'
export default {
  name: 'PropertyCellChopsListForm',
  components: {
    STable
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      zonePropertyCellsList: [],
      zonePropertyCellChopsList: [],
      corList: [],
      form: this.$form.createForm(this),
      cell_loading: false,
      cellChopsloading: false,
      propertyData: {},
      propertyCellData: {},
      propertyCellChopData: {},
      queryParam: {},
      queryCellParam: {},
      queryCellChopsParam: {},
      propertyCellTotal: 0,
      index: 0,
      steps: [
        {
          title: '第一步',
          content: '资产列表'
        },
        {
          title: '第二步',
          content: '资产明细'
        },
        {
          title: '第三步',
          content: '资产明细展示'
        },
        {
          title: '第四步',
          content: '选中内容'
        }
      ],
      current: 1,
      propertyCellChopsTotal: 0,
      propertyCellChopsCurrent: 1,
      max_area: 0,
      // 表头
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          ellipsis: true
        },
        {
          title: '租金',
          dataIndex: 'standard_price',
          customRender: (text) => (text / 100).toFixed(6),
          ellipsis: true
        },
        {
          title: '物业费',
          dataIndex: 'fee',
          customRender: (text) => (text / 10000).toFixed(4),
          ellipsis: true
        },
        {
          title: '所有人',
          dataIndex: 'property_owner',
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.electricity_meter_property_owner[text]
        }
      ],
      columns_cell: [
        {
          title: '名称',
          dataIndex: 'name',
          ellipsis: true
        },
        {
          title: '产权面积',
          dataIndex: 'property_area',
          ellipsis: true
        },
        {
          title: '真实面积',
          dataIndex: 'real_area',
          ellipsis: true
        },
        {
          title: '可用面积',
          dataIndex: 'available_area',
          ellipsis: true
        }
      ],
      columnsCellChops: [
        {
          title: '编号',
          dataIndex: 'number',
          ellipsis: true
        },
        {
          title: '面积',
          dataIndex: 'area',
          ellipsis: true
        },
        {
          title: '是否已出租',
          dataIndex: 'is_rented',
          ellipsis: true,
          customRender: (text) => text ? '是' : '否'
        }
      ],
      columnsCellChopsSelected: [
        {
          title: '名称',
          width: 100,
          dataIndex: 'name',
          ellipsis: true
        },
        {
          title: '编号',
          width: 100,
          dataIndex: 'number',
          ellipsis: true
        },
        {
          title: '面积',
          width: 100,
          dataIndex: 'area',
          ellipsis: true
        },
        {
          title: '是否已出租',
          width: 100,
          dataIndex: 'is_rented',
          ellipsis: true,
          customRender: (text) => text ? '是' : '否'
        },
        {
          width: 100,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      selectedCellChopsList: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return zone_property_list(Object.assign(parameter, this.queryParam, { page_size: 5 }))
          .then(res => {
            this.loading = false
            this.cell_loading = false
            return res.data
          })
      }
    }
  },
  computed: {
    rowSelection () {
      const that = this
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          that.onSelectChange(selectedRowKeys, selectedRows)
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.is_rented
          }
        })
      }
    },
    nextDisabled () {
      return (index) => {
        if (index === 0 && Object.keys(this.propertyData).length > 0) {
          return false
        } else if (index === 1 && Object.keys(this.propertyCellData).length > 0) {
          return false
        } else if (index === 2 && this.selectedRows.length > 0) {
          return false
        } else if (index === 3 && this.selectedCellChopsList.length > 0) {
          return false
        }
        return true
      }
    }
  },
  methods: {
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      const selectedCellChopsIds = this.selectedCellChopsList.map(item => item.id)
      this.selectedCellChopsList.push(...this.selectedRows.filter(item => !selectedCellChopsIds.includes(item.id)).map(item => {
        item.name = this.propertyData['name'] + ' / ' + this.propertyCellData['name']
        item.zone_property_cell_id = this.propertyCellData['id']
        return item
      }))
    },
    next () {
      this.index++
    },
    prev () {
      this.index--
    },
    handleDelete (record) {
      this.selectedCellChopsList = this.selectedCellChopsList.filter(item => record.id !== item.id)
    },
    modalcancel (e) {
      this.$emit('cancel')
    },
    modalok () {
      if (this.selectedCellChopsList.length === 0) {
        this.$message.warning('没有选中的内容')
        return
      }
      this.$emit('ok', this.selectedCellChopsList)
    },
    itemClick (record, index) {
      const that = this
      return {
        style: {
          // 字体颜色
          color: record.id === this.propertyData.id ? 'black' : '',
          // 背景颜色
          'background-color': record.id === this.propertyData.id ? 'rgb(0, 180, 237,0.2)' : ''
        },
         on: {
          click: function (event) {
            that.form.resetFields() // 清理表单数据（可不做）
            that.propertyData = record
            that.max_area = 0
            that.getZonePropertyCellsList(record.id)
            console.log(that.propertyData)
          }
        }
      }
    },
    handleTableChange (pagination) {
      console.log(pagination)
      this.current = pagination.current
      this.getZonePropertyCellsList(-1)
    },
    itemCellClick (record, index) {
      const that = this
      return {
        style: {
          // 字体颜色
          color: record.id === this.propertyCellData.id ? 'black' : '',
          // 背景颜色
          'background-color': record.id === this.propertyCellData.id ? 'rgb(0, 180, 237,0.3)' : ''
        },
        on: {
          click: function (event) {
            that.getZonePropertyCellChopsList(record.id)
            that.propertyCellData = record
            // const property = {
            //   zone_property_cell_id: record.id,
            //   rental_price: (that.propertyData.standard_price / 100).toFixed(6),
            //   property_price: (that.propertyData.fee / 10000).toFixed(4),
            //   used: record.available_area,
            //   name: that.propertyData.name + ' / ' + record.name,
            //   property_owner: that.propertyData.property_owner
            // }
            // console.log(record)
            // that.max_area = record.available_area
            // // 防止表单未注册
            // fields.forEach(v => that.form.getFieldDecorator(v))
            // that.form.setFieldsValue(pick(property, fields))
          }
        }
      }
    },
    itemCellChopsClick (record, index) {
      const that = this
      return {
        style: {
          // 字体颜色
          color: record.id === this.propertyCellChopData.id ? 'black' : '',
          // 背景颜色
          'background-color': record.id === this.propertyCellChopData.id ? 'rgb(0, 180, 237,0.2)' : ''
        },
        on: {
          click: function (event) {
            that.getZonePropertyCellChopsList(record.id)
            this.propertyCellChopData = record
          }
        }
      }
    },
    getZonePropertyCellsList (id) {
      if (this.propertyData === undefined) {
        return
      }
      if (id === -1) {
        id = this.propertyData.id
      }
      this.cell_loading = true
      this.zonePropertyCellsList = []
      zone_property_cell_list(Object.assign(this.queryCellParam, { zone_property_id: id, page_size: 5, page: this.current }))
        .then(({ data }) => {
          this.cell_loading = false
          this.zonePropertyCellsList = data.entries
          this.propertyCellTotal = data.total
          this.current = data.page_number
          return this.zonePropertyCellsList
        })
    },
    getZonePropertyCellChopsList (id) {
      this.cellChopsloading = true
      this.zonePropertyCellChopsList = []
      zone_property_cell_chops_list(Object.assign({}, { zone_property_cell_id: id, page_size: 100, page: 1 }))
        .then(({ data }) => {
          this.zonePropertyCellChopsList = data.entries
          this.propertyCellChopsTotal = data.total
          this.propertyCellChopsCurrent = data.page_number
          return this.zonePropertyCellChopsList
        }).finally(() => {
        this.cellChopsloading = false
      })
    }
  }
}
</script>
